import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { queryClient } from './api/queryClient';
// Composants .jsx herites du prototype : resolus via allowJs, non type-checkes.
// Ils seront convertis en .tsx au fil des lots.
import App from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Element #root introuvable dans index.html');

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
